import { Settings, WidgetData } from './data'
import { Widget } from './widget'

export type ButtonData = WidgetData & {
  settings: Settings & {
    text: string
    button_css_id: string | null | undefined
    link?: {
      url: string
      is_external: string
      nofollow: string
      custom_attributes: string
    }
  }
  widgetType: 'button'
}

export class ButtonWidget extends Widget {
  text: string
  button_css_id: string | null | undefined
  link: string | undefined

  constructor (data: ButtonData) {
    super(data)
    this.text = data.settings.text
    this.link = data.settings.link?.url
    this.button_css_id = data.settings?.button_css_id
  }
}
